import { agentCaller } from "../../lib/ai/agentCaller";
import { getProjectProfileString } from '../../lib/getProjectProfile';

export const importDataTableGeneration = async ({settings, projectId, organizationId, userId, tableData}) => {
    
  console.log('settings', settings)
  console.log('table data', tableData)

  const agentName = settings.agent;
  const prompt = settings.prompt;
  const columns = tableData.column_order;
  const currentData = tableData.dataset;
  const importData = tableData.importData;

  let systemPrompt = `You are a data table import assistant. You analyze CSV data and merge it with existing table data based on these rules:
  Output Rules:
      1. Output only valid JSON that can be parsed with JSON.parse()
      2. Output must be an object with two properties: dataset and column_order
      3. The dataset must be an array of objects with consistent structure
      4. Use proper data types (string, number, boolean, etc.)
      5. Do not include any explanatory text before or after the JSON
      6. Do not use comments or trailing commas
      7. Use double quotes for property names and string values
      8. Match imported columns to existing ones where possible
      9. Add new columns when needed
      10. Preserve all existing data and append new data
      11. Each object must be a flat structure (no nested objects or arrays)
      
      Example output format:
      {
        "dataset": [
          {
            "column1": "value1",
            "column2": "value2"
          }
        ],
        "column_order": ["column1", "column2"]
      }

      Current table structure:
      Column order: ${JSON.stringify(columns)}
      Existing data: ${JSON.stringify(currentData)}
      Import data: ${JSON.stringify(importData)}
      `;
  
  const userPrompt = `${prompt}`;

  let result = await agentCaller({
    userPrompt, 
    systemPrompt, 
    agentName, 
    projectId, 
    organizationId, 
    currentUserId: userId 
  });
  
  if (!result.success) {
    return {
      success: false,
      error: result.error,
    };
  }

  let content = result.output;
  content = processJsonOutput(content);
    
  return {
    success: true,
    output: content,
  };
};
export const executeDataTableGeneration = async ({settings, projectId, organizationId, userId, tableData, referenceDocs}) => {
    
  console.log('settings', settings)
  console.log('table data', tableData)

  const agentName = settings.agent;
  const prompt = settings.prompt;
  const columns = tableData.column_order;
  const currentData = tableData.dataset;

  const referenceDocsString = referenceDocs.map(doc => `Document ${doc.content}`).join('\n');

  let systemPrompt = `You are a data table generator, you take all the information given and generate a response based on the following rules.
  Output Rules:
      1. Output only valid JSON that can be parsed with JSON.parse()
      2. Output must be an array of objects with consistent structure
      3. Use proper data types (string, number, boolean, etc.)
      4. Do not include any explanatory text before or after the JSON
      5. Do not use comments or trailing commas
      6. Use double quotes for property names and string values
      7. Your output must match the existing table structure unless you are asked to replace them or you need to create new ones.
      8. You always add to the existing data and never replace it unless your instructions ask you to do so.
      9. Each object must be a flat structure with single-level key-value pairs only (no nested objects or arrays)
      10. Example of valid structure:
      [
        {
          "first_name": "John",
          "age": 25,
          "is_active": true
        }
      ]
      11. Example of invalid nested structure:
          [
            {
              "user": {
                "name": "John"
              }
            }
          ]

      Current table structure and data:
      Existing table data: ${JSON.stringify(currentData || [])}

      ${referenceDocs.length > 0 && 'Take into account the following reference documents:' + referenceDocsString}
      

      `;
  
  const userPrompt = `${prompt}`;

  let result = await agentCaller({
    userPrompt, 
    systemPrompt, 
    agentName, 
    projectId, 
    organizationId, 
    currentUserId: userId 
  });
  
  if (!result.success) {
    return {
      success: false,
      error: result.error,
    };
  }

  let content = result.output;
  content = processJsonOutput(content);
    
  return {
    success: true,
    output: content,
  };
};
export const executeDocumentGeneration = async ({settings,projectId, organizationId, userId, referenceDocs, existingContent}) => {
    
  console.log('settings', settings)

  console.log('referenceDocs', referenceDocs)

  const agentName = settings.agent;
  const prompt = settings.prompt;

  const referenceDocsString = referenceDocs.map(doc => `Document ${doc.content}`).join('\n');

    let systemPrompt = `You are a content generator. You take all the information given and generate a response.
    You get straight to the point with your output and do not include confirmations of what you have done. You focus on the output the user was requesting.
    You never use markdown language and only ever respond with HTML using the correct tags that can be viewed in an HTML body. You will normally start your response with an H1 tag.
    Example
    <H1>header content</H1>
    <p>Introduction</p>
    ...etc`;
    
    const userPrompt = `Create a document with the following brief: ${prompt}  
    ${referenceDocs.length > 0 && 'Take into account the following reference documents:' + referenceDocsString}
    Existing content: ${existingContent}
    `

    console.log('userPrompt', userPrompt)

    let result = await agentCaller({userPrompt, systemPrompt, agentName, projectId, organizationId, currentUserId: userId });

    console.log('document result', result)
    
    if (!result.success) {
      return {
        success: false,
        error: result.error,
      };
    }

    let content = result.output;

    // convert the content to html with agent.
    
    content = await htmlAgent({content, projectId, organizationId, userId});
    
    return {
      success: true,
      output: content,
    };
};
export const executeBlog = async ({ userPrompt, wordCount, projectId, organizationId, userId }) => {


  // CALL PERPLEXITY

  const sPrompt_research = `You are a research assistant that takes topics and article titles provides the information required for a content writer to be able to create engaging copy. Your response gives everything needed for the writer to complete their task. the content writer has the opportunity to get more detailed information on a subject and so you should prioritise the the main points you consider relevant.`
  const uPrompt_research = `Generate the content brief for the following - ${userPrompt}.`

  // uPrompt_research = uPrompt_research.replace(/["\n\r\t]/g, ' ')

  let result_research = await callApi(uPrompt_research, sPrompt_research, 'perry', organizationId, userId, projectId);

  if (!result_research.success) {
    return {
      success: false,
      error: result_research.error,
    };
  }

  let content_research = result_research.output;
  
  const sPrompt = `You are a content writer with 30 years experience that generates engaging, authoritative content from a given brief. you only write in British English grammar and spelling. You should always prioritise engaging and educating and audience of being too technical or going to deep on a subject. Your output always includes a suggested title together with the content. You never include a summary or conclusion section at the end of the content and instead, if you feel it would benefit the reader, you might include a paragraph at the end that gives them something to think about or consider further.
                      Your final response is always a parseable JSON object, using correct syntax that can be parsed by javascript. for example:

                      {
                        "title": "This is the title",
                        "content": "<h1>content title</h1>"
                      }

                      When you add the content to the json object you only ever use HTML and valid HTML tags. For example, you will begin your content with an H1 tag for the title and use relevant H2, H3, <p>, etc. tags as required.`;
  

  const uPrompt = `Create an article of around ${wordCount} words using the following brief ${content_research} and 
                    help to generate a title that is better than ${userPrompt}`

  let result = await callApi(uPrompt, sPrompt, 'dave', organizationId, userId, projectId);

  if (!result.success) {
    return {
      success: false,
      error: result.error,
    };
  }

  let content = result.output;
  
  content = processJsonOutput(content);
  
  return {
    success: true,
    output: content,
  };



}
export const executeSocial = async ({ 
  userPrompt,
  projectId,
  organizationId,
  userId,
  networkType
}) => {
  const sPrompt = 'You are a Social Content Writing Agent specialising in ' + networkType + ' that creates engaging, platform-optimised posts. You adapt content briefs into compelling social copy that drives engagement while maintaining brand voice and meeting marketing objectives.';
  const uPrompt = `Create a single Social Media post for ${networkType} with this brief: ${userPrompt}. Output only a JSON object no other response is needed. Example response: 
  {
    title: string,
    content: string (including hashtags/emojis)
  }`;

  let result = await callApi(
    uPrompt, 
    sPrompt, 
    'dave',
    organizationId,
    userId,
    projectId
  );

  if (!result.success) {
    return {
      success: false,
      error: result.error,
    };
  }

  let content = result.output;
  content = processJsonOutput(content);
  
  return {
    success: true,
    output: content,
  };
};
const callApi = async (userPrompt, systemPrompt, agentName, organizationId, userId, projectId) => {


  const payload = {
    userPrompt: userPrompt,
    systemPrompt: systemPrompt,
    agentName: agentName,
    projectId,
    organizationId,
    currentUserId: userId
  };

  let result = await agentCaller(payload);

  return result;
}

export const htmlAgent = async ({content, projectId, organizationId, userId}) => {

  const sPrompt = 'You are a HTML conversion agent that takes a string of content and converts it into HTML. You only ever respond with HTML and valid HTML tags. Your first tag is usually an H1 tag.';

  const uPrompt = `Convert the following content into HTML: ${content}`;

  let result = await agentCaller({userPrompt: uPrompt, systemPrompt: sPrompt, agentName: 'dave', projectId, organizationId, currentUserId: userId});

  let html = result.output;
    
  html = processHtmlOutput(html);

  return html;
}

// export const executeAgent = async ({
//     userPrompt,
//     wordCount,
//     agentName,
//     outputType
//   }) => {

//     const agent = agents[agentName];

//     try {
      
//       // Prepare the request payload
//       const payload = {
//         userPrompt: userPrompt,
//         wordCount: wordCount,
//       };
  
//       console.log('Payload:', payload);
  
//       // Call endpoint
//       const response = await fetch(`${agent.endpoint}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(payload)
//       });
  
//       if (!response.ok) {
//         throw new Error(`API Error: ${response.status}`);
//       }
  
//       let data = await response.json();
      
//       data = outputType === 'json' ? processJsonOutput(data) : data;
  
//       console.log('Jeff Data.Result:', data.result);
  
//       return {
//         success: true,
//         output: data.result,
//       };
  
//     } catch (error) {
//       console.error(`Error executing Jeff node:`, error);
//       return {
//         success: false,
//         error: error.message,
//       };
//     }
// };

export const processJsonOutput = (data) => {

    try {
        if (typeof data === 'string') {
          let cleanedString = data.replace(/```json\n|\n```$/g, '');
          cleanedString = cleanedString.replace(/[\r\t]/g, '');
          data = JSON.parse(cleanedString);
        } else if (Array.isArray(data) || (typeof data === 'object' && data !== null)) {

            console.log('here')
          data = data;
        }
    } catch (e) {
        console.warn('Failed to parse JSON response:', e);
        const cleanedError = data.replace(/```json\n|\n```$|[\r\t]/g, '');
        data = `{"error": "Failed to parse JSON", "originalResponse": "${cleanedError}"}`;
    }

    return data;
}

export const processHtmlOutput = (data) => {

  try {
    if (typeof data === 'string') {
      data = data.replace(/```html\n|\n```$/g, '');
      data = data.replace(/[\r\t]/g, '');
    }
  } catch (e) {
    console.warn('Failed to clean HTML response:', e);
  }

  return data;

}